import React, { useEffect, useState } from "react";
import {
  Box,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Stack,
  TableContainer,
  Select,
  useColorModeValue,
  InputGroup,
  InputLeftElement,
  Skeleton,
} from "@chakra-ui/react";
import axiosClient from "../../axios-client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MyPagination from "../../components/MyPagination";
import { SearchIcon } from "@chakra-ui/icons";

const PromoCodeUsage = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [paginationData, setPaginationData] = useState()
  const [checkLengthData, setCheckLengthData] = useState(false)
  const [loadingData, setLoadingData] = useState(true)

  const [currentPage, setCurrentPage] = useState(0);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate()
  const { t } = useTranslation()
  ////////////////////////////////the size of the table//////////////////////////////
  const PAGE_SIZE = 10;
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  //////////////////////////////////////////////////////////////////////////////////

  const fetchData = async () => {
    try {
      axiosClient.get(`/promo-code-usage/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}`)
        .then((response) => {
          let filteredData = response.data.results;
          setPaginationData(response.data);

          if (filteredData.length === 0) {
            setCheckLengthData(true)
          }
          else {
            setData(filteredData);
          }
          setLoadingData(false)
        })
        .catch((error) => {
          // console.error(error);
          setLoadingData(false)

        });
    } catch (err) {
      console.error("Error fetching promo code usage:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageSize, currentPage, searchTerm]);



  return (
    <Box mt="5px" >
      <Flex>
        <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
          <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>  / <span >Utilisation des codes promo</span></Text>

        </Box>
      </Flex>

      <Flex
        align={'center'}
        justify={'center'}
      >
        <Stack
          w={'full'}
          maxW='full'
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'lg'}
          p={6}
          my={5}>
          <Flex
            justifyContent="end"
            alignItems="center"
            direction={{ base: 'column', lg: 'row' }}
          >
            <InputGroup size="sm" w={{ base: '100%', lg: "40%" }}>
              <InputLeftElement
                pointerEvents='none'
                children={<SearchIcon color='gray.300' />}
              />
              <Input
                borderRadius="5"
                placeholder={t("Recherche...")}
                value={searchTerm}
                onChange={(e) => {
                  setCurrentPage(0)
                  setSearchTerm(e.target.value)
                }}
                mb={4}
                sx={{
                  marginLeft: 'auto',
                }}
              />  </InputGroup>

          </Flex>

          {/* Table */}
          <TableContainer>

            <Table size="sm">
              <Thead size="sm">
                <Tr>
                  <Th fontFamily='Plus Jakarta Display' fontSize="12">Utilisateur</Th>
                  <Th fontFamily='Plus Jakarta Display' fontSize="12">Email</Th>
                  <Th fontFamily='Plus Jakarta Display' fontSize="12">Code promo</Th>
                  <Th fontFamily='Plus Jakarta Display' fontSize="12">Influenceur</Th>
                  <Th fontFamily='Plus Jakarta Display' fontSize="12">Nombre d'utilisation</Th>
                  <Th fontFamily='Plus Jakarta Display' fontSize="12">Date</Th>
                </Tr>
              </Thead>
              <Tbody>
                {loadingData &&
                  <Tr>

                    <Td> <Skeleton height='20px' /></Td>
                    <Td> <Skeleton height='20px' /></Td>
                    <Td> <Skeleton height='20px' /></Td>
                    <Td> <Skeleton height='20px' /></Td>
                    <Td> <Skeleton height='20px' /></Td>
                    <Td> <Skeleton height='20px' /></Td>
                  </Tr>}
                {(paginationData?.length !== 0) &&
                  data.map((row, idx) => (
                    <Tr key={idx}>
                      <Td>{row.user}</Td>
                      <Td>{row.email}</Td>
                      <Td>{row.promo_code}</Td>
                      <Td>{row.influencer}</Td>
                      <Td>{row.usage_count}</Td>
                      <Td>{new Date(row.payment_date).toLocaleString("fr-FR", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}</Td>

                    </Tr>
                  ))}
                {(((searchTerm) && paginationData?.length === 0) || (checkLengthData)) && (
                  <Tr>
                    <Td colSpan={11}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          {/* Pagination */}
          <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
            <Box flex="1">
              <MyPagination
                paginationData={paginationData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                PAGE_SIZE={pageSize}
              />
            </Box>

            <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              {/* Add more options as needed */}
            </Select>
          </Flex>
        </Stack>
      </Flex>


    </Box>
  );
};

export default PromoCodeUsage;
